import {inject, Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {IResult} from "../interfaces/result";
import {map, Observable} from "rxjs";
import {CommunicationConstants} from "../constants/communication";

const API_MAIN = environment.security + environment.host + environment.version + environment.typeService;

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  private URL_MENU: string = API_MAIN + "user-api/get-menu-by-user";

  private readonly httpClient: HttpClient = inject(HttpClient);

  getMenu(): Observable<any>{
    return this.httpClient.post<IResult<any>>(this.URL_MENU, {}).pipe(
      map((res: IResult<any>) => {
        const [codigosCom, mensajesCom] = CommunicationConstants;
        if (res === null) throw new Error(`${codigosCom.ERRORSRV}||${mensajesCom.MSGDATAVACIOSRV}`);
        if(!res.Succeeded) throw new Error(`${res.Message}`);
        return res.Data;
      })
    );
  }
}
